import { formatNumber } from "./format";

export function formatKcalBalance(value: number): string {
  return value < 0 ? `${formatNumber(Math.abs(value))} over goal` : `${formatNumber(value)} remaining`;
}
